import options from './chart-proximity-agg.component';

export default {
    selector: 'dtChartProximityAgg',
    options
};
